/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SubscriptionSourceTypeEnum = 'LEGACY' | 'CSP_V4' | 'QA' | 'ERP';

export const SubscriptionSourceTypeEnum = {

    LEGACY: 'LEGACY' as SubscriptionSourceTypeEnum,

    CSP_V4: 'CSP_V4' as SubscriptionSourceTypeEnum,

    QA: 'QA' as SubscriptionSourceTypeEnum,

    ERP: 'ERP' as SubscriptionSourceTypeEnum
};

